module.exports = __webpack_public_path__ + "img/ab365aa.png";